import React from 'react';
export * from './QueryParameterContext';
export * from './StaticPropsContext';
export * from './SearchResultContext';

import { QueryParameterContext } from './QueryParameterContext';
import { StaticPropsContextProvider } from './StaticPropsContext';
import { SearchResultContextProvider } from './SearchResultContext';
import { CourseMappingsPageInitialProps } from '../data/useCourseMappingsPageProps';

interface CourseMappingsContextProvider {
  children: React.ReactNode;
  initialProps: CourseMappingsPageInitialProps;
}

export function CourseMappingsProvider(props: CourseMappingsContextProvider) {
  return (
    <StaticPropsContextProvider initialProps={props.initialProps}>
      <QueryParameterContext>
        <SearchResultContextProvider>{props.children}</SearchResultContextProvider>
      </QueryParameterContext>
    </StaticPropsContextProvider>
  );
}
